export enum ToastId {
  SUCCESS_TOAST = 'success_toast_id',
  ERROR_TOAST = 'error_toast_id',
}
